import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";
import { applyGlobalLocale, SUPPORTED_LANGUAGES } from "./locale";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	fallbackLng: "pt",
	ns: ["translations"],
	resources: messages,
	supportedLngs: SUPPORTED_LANGUAGES,
	nonExplicitSupportedLngs: true, // pt-BR → pt, en-US → en, es-AR → es
	load: "languageOnly",
	initImmediate: false, // recursos embutidos: inicializa síncrono, antes do primeiro render
	interpolation: { escapeValue: false }, // o React já escapa; evita &#39; em nomes
	detection: {
		order: ["localStorage", "navigator"],
		caches: ["localStorage"],
	},
});

// Locale de moment / MUI / date-fns / <html lang> segue o idioma escolhido.
i18n.on("languageChanged", applyGlobalLocale);
applyGlobalLocale();

export { i18n };
